<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Stores
	import AdminUserStore from '@/Stores/AdminUserStore';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import PhoneInput from '@/Components/PhoneInput.svelte';
	import CountrySelector from '@/Components/CountrySelector.svelte';
	// Services
	import { notify } from '@/Services/Notify';

	export let open;

	let sending = false;
	let errors = null;

	$: errors = null;

	let formData = {
		first_name: undefined,
		last_name: undefined,
		name: undefined,
		email: undefined,
		country: undefined,
		phone: undefined,
		password: undefined,
		password_confirm: undefined
	};

	const dispatch = createEventDispatcher();

	function createAdminUser() {
		sending = true;
		AdminUserStore.createAdminUser(formData)
			.then(() => {
				notify({
					type: 'success',
					title: 'Admin User created',
					message: 'Admin User Successfully created!',
					timeout: 3
				});
				dispatch('created');
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Problem Creating New Admin User',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Create Admin User</h2>
		<form on:submit|preventDefault={createAdminUser}>
			<div class="flex flex-col w-full px-4 pt-2">
				<TextInput
					className="pb-4 w-full"
					label="First Name"
					name="first_name"
					type="text"
					required
					placeholder="First Name"
					errors={errors && errors.first_name}
					bind:value={formData.first_name}
				/>

				<TextInput
					className="pb-4 w-full"
					label="Last Name"
					name="last_name"
					type="text"
					required
					placeholder="Last Name"
					errors={errors && errors.last_name}
					bind:value={formData.last_name}
				/>

				<TextInput
					className="pb-4 w-full"
					label="Username"
					name="name"
					type="text"
					required
					placeholder="Username"
					errors={errors && errors.name}
					bind:value={formData.name}
				/>

				<TextInput
					className="pb-4 w-full"
					label="Email"
					name="email"
					type="email"
					required
					placeholder="Enter a valid Email"
					errors={errors && errors.email}
					bind:value={formData.email}
				/>

				<CountrySelector
					bind:value={formData.country}
					className="pb-4 w-full text-left"
					errors={errors && errors.country}
					label="Country"
					name="country"
					required
				/>

				<PhoneInput
					bind:country={formData.country}
					bind:value={formData.phone}
					className="pb-4 w-full text-left"
					errors={errors && errors.phone}
					label="Mobile Number"
					name="phone"
					required
					type="text"
				/>

				<TextInput
					className="pb-4 w-full"
					label="Password"
					name="password"
					type="password"
					required
					errors={errors && errors.password}
					bind:value={formData.password}
				/>

				<TextInput
					className="pb-4 w-full"
					label="Confirm password"
					name="confirm_password"
					type="password"
					required
					errors={errors && errors.confirm_password}
					bind:value={formData.confirm_password}
				/>

				{#if errors && errors[0]}
					<div class="my-3 text-center whitespace-pre-wrap form-error">
						{errors[0]}
					</div>
				{/if}
				<LoadingButton type="submit" loading={sending} className="mb-4 btn btn-primary">Create</LoadingButton>
				<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
			</div>
		</form>
	</Modal>
{/if}
